import { FONT_FACE_CALIBRI, FONT_FACE_DAGNY_DISPLAY, FONT_FACE_DAGNY_TEXT, FONT_FACE_NITTI_GROTESK_NN_HEADING, FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD, FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM, FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR, } from '../../../../constants';
export function getFontFamily(transformer) {
    return Object.freeze({
        dagnyDisplay: transformer.fontFamily(FONT_FACE_DAGNY_DISPLAY),
        dagnyText: transformer.fontFamily(FONT_FACE_DAGNY_TEXT),
        nittiGroteskHeading: transformer.fontFamily(FONT_FACE_NITTI_GROTESK_NN_HEADING),
        nittiGroteskTextRegular: transformer.fontFamily(FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR),
        nittiGroteskTextMedium: transformer.fontFamily(FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM),
        nittiGroteskTextBold: transformer.fontFamily(FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD),
        calibri: transformer.fontFamily(FONT_FACE_CALIBRI),
    });
}
